import { Spine } from "@esotericsoftware/spine-pixi-v8";
// import { sound } from "@pixi/sound";
import { sound } from "@pixi/sound";
import { DestroyOptions } from "pixi.js";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";

export class Character extends DisplayObject {
    private character: Spine | null = null;
    private intendedAnim: string;
    private lastNonIdleTime: number = Date.now();
    private idleCheckTicker?: ReturnType<typeof setInterval>;
    private idleVariants = ["idle"];

    constructor(config: IDisplayObject) {
        super(config);
        this.init();
        this.subscribeToEvents();
    }

    public override destroy(options?: DestroyOptions): void {
        this.stopIdleCheck();
        this.unsubscribeToEvents();
        super.destroy(options);
    }

    public animateCharacter(name?: string): void {
        const animations = ["win_1", "win_2"];
        const randomIndex = Math.floor(Math.random() * animations.length);
        const winVariant = animations[randomIndex];
        this.intendedAnim = (name) ? name : winVariant;
        this.character?.state.setEmptyAnimation(0, 0);
        this.character?.state.setAnimation(0, `${this.intendedAnim}`, false);
    }

    public speedupCharacterAnim() {
        this.character.state.timeScale = 2;
    }

    public resetSpeedCharacterAnim() {
        this.character.state.timeScale = 1;
    }

    private init(): void {
        this.character = Spine.from({
            skeleton: "characterSkel",
            atlas: "characterAtlas"
        });

        const animations = this.character.skeleton.data.animations.map(anim => anim.name);
        console.log("Available character animations:", animations);

        const data = this.character.state.data;
        data.defaultMix = 0.25;

        this.addChild(this.character);
        // // Add listener to return to "idle" after the win animation completes
        this.character.state.addListener(this.stateListener);

        this.intendedAnim = "idle";
        this.character?.state.setEmptyAnimation(0, 0);
        this.character.state.setAnimation(0, "idle", true);
        this.character.state.timeScale = 1;

        // // Start periodic check
        if (this.idleVariants.length > 1) {
            this.startIdleCheck();
        }
    }

    private stateListener = {
        start: (entry: any) => {

            if (entry.animation.name !== this.intendedAnim) {
                // console.warn(`Sound skipped: started ${entry.animation.name}, but expected ${this.intendedAnim}`);
                return;
            }
            switch (entry.animation.name) {
                case "win_1":
                    break;
                case "win_2":
                    setTimeout(() => {
                        sound.play('glass_sip', { volume: 0.25 });
                    }, 700);
                    break;
            }

        },
        event: (_entry: any, event: { data: { name: string; }; }) => {
            if (event.data.name === "win_1" || event.data.name === "win_2") {
                // this.shakeEffect();
            }
        },
        complete: (entry: any) => {
            if (["idle", "win_1", "win_2"].includes(entry.animation.name)) {
                this.intendedAnim = "idle";
                this.character?.state.setEmptyAnimation(0, 0);
                this.character?.state.setAnimation(0, "idle", true);
            }

            // If animation is not idle, update the timestamp
            if (entry.animation.name !== "idle") {
                this.lastNonIdleTime = Date.now();
            }
        }
    }

    private startIdleCheck(): void {
        if (this.idleCheckTicker) return; // prevent duplicate intervals

        const idleCheckInterval: number = 15000; // Check every 500ms
        let idleThreshold: number = 5000 + Math.floor(Math.random() * 10000); // 5 seconds



        this.idleCheckTicker = setInterval(() => {
            const now = Date.now();
            const currentAnim = this.character?.state.getCurrent(0)?.animation.name;

            if (currentAnim === "idle" && (now - this.lastNonIdleTime >= idleThreshold)) {
                // Select a random idle variant
                const randomAnim = this.idleVariants[Math.floor(Math.random() * this.idleVariants.length)];
                this.intendedAnim = randomAnim;
                this.character?.state.setEmptyAnimation(0, 0);
                this.character?.state.setAnimation(0, randomAnim, false);

                // sound.play('man_anim_sword_to_hand', { volume: 0.5 });
                this.lastNonIdleTime = now; // reset timer after playing a variant
                idleThreshold = 5000 + Math.floor(Math.random() * 10000); // reset idleThreshold 10-20 sec - check after that
            }
        }, idleCheckInterval);
    }

    private stopIdleCheck(): void {
        if (this.idleCheckTicker) {
            clearInterval(this.idleCheckTicker);
            this.idleCheckTicker = undefined;
        }
    }

    private subscribeToEvents() {
        this.character.eventMode = "static";
        // this.character.on("pointerdown", this.onCharacterClick);
    }

    private unsubscribeToEvents() {
        this.character.state.removeListener(this.stateListener);
        this.character.eventMode = "static";
        // this.character.off("pointerdown", this.onCharacterClick);
    }

    //@ts-ignore
    private onCharacterClick = () => {

        const currentAnim = this.character?.state.getCurrent(0)?.animation?.name;

        if (currentAnim === "idle") {
            const animations = ["win_1", "win_2"];
            const randomIndex = Math.floor(Math.random() * animations.length);
            const winVariant = animations[randomIndex];
            this.intendedAnim = winVariant;
            this.character?.state.setEmptyAnimation(0, 0);
            this.character?.state.setAnimation(0, winVariant, false);
            console.log("winVariant ", winVariant);
        }
    }
}
